import React from 'react';
import ToggleButton from 'react-bootstrap/ToggleButton';


export default function QualifierToggleGroup({ qualifiers, setQualifiers, text, disqualifier = false }) {
  const updateToggleStatus = index => {
    window.gtag('event', 'toggle_qualifier_button', {
      'event_label': text,
      'selected_values': qualifiers.filter(q => q.checked).join(", ")
    });

    setQualifiers(
      qualifiers.map((q, i) =>
        i === index
          ? { ...q, checked: !q.checked }
          : q
      )
    )
  }

  return (
    <div>
      <p>{text + " "}
        {
          qualifiers.map((q, index) => (
            <ToggleButton
              key={q.name}
              id={`q-${index}-${text}`}
              type="checkbox"
              variant={disqualifier === false ? "outline-primary" : "outline-danger"}
              checked={q.checked}
              onChange={() => updateToggleStatus(index)}
            >
              {q.name}
            </ToggleButton>
          ))
        }</p>
    </div >
  )
}